import { createContext, useContext } from "react";

export const ResetSessionContext = createContext<(() => void) | null>(null);

export function useResetSession(): () => void {
  const resetSession = useContext(ResetSessionContext);

  if (resetSession === null)
    throw new Error("Session verification requires ProductSession");

  return resetSession;
}
